const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || "dev";

export function withStaticAssetVersion(path) {
    const divider = path.includes("?") ? "&" : "?";
    return `${path}${divider}v=${encodeURIComponent(BUILD_VERSION)}`;
}
